import {
  BulkEmployeeImportRow,
  BulkEmployeeImportValidationResult,
} from "../types/Employee";

export type EmployeeImportReviewTab = "ALL" | "INVALID" | "BOOMERANG" | "READY";

export function isEmployeeImportCommitEligible(row: BulkEmployeeImportRow) {
  return row.status === "VALID" || row.status === "RESOLVED_BOOMERANG";
}

export function isEmployeeImportInvalidRow(row: BulkEmployeeImportRow) {
  return row.status === "ERROR" || row.status === "ACTIVE_DUPLICATE";
}

export function employeeImportReviewTabForRow(
  row: BulkEmployeeImportRow
): Exclude<EmployeeImportReviewTab, "ALL"> {
  if (isEmployeeImportInvalidRow(row)) return "INVALID";
  if (
    row.status === "BOOMERANG_CANDIDATE" ||
    row.status === "RESOLVED_BOOMERANG"
  ) {
    return "BOOMERANG";
  }
  return "READY";
}

export function getEmployeeImportRowsForTab(
  rows: BulkEmployeeImportRow[],
  tab: EmployeeImportReviewTab
) {
  return tab === "ALL"
    ? rows
    : rows.filter((row) => employeeImportReviewTabForRow(row) === tab);
}

export function getEmployeeImportReviewSummary(
  rows: BulkEmployeeImportRow[]
): BulkEmployeeImportValidationResult["summary"] {
  return {
    totalRows: rows.length,
    validRows: rows.filter((row) => row.status === "VALID").length,
    errorRows: getEmployeeImportRowsForTab(rows, "INVALID").length,
    boomerangCandidates: getEmployeeImportRowsForTab(rows, "BOOMERANG").length,
    commitEligibleRows: getEmployeeImportRowsForTab(rows, "READY").length,
  };
}
